module.exports = __webpack_public_path__ + "img/loreto-costa.a78660f6.jpg";